import { type ApiError, api } from "@/lib/api";
import type { UserProfile } from "@/types";

export async function updateProfile(data: {
  username?: string;
  displayName?: string;
  timezone?: string;
  avatarUrl?: string;
}): Promise<{ data: UserProfile | null; error: ApiError | null }> {
  return api.patch<UserProfile>("/profiles/me", data);
}

export async function changePassword(data: {
  currentPassword: string;
  newPassword: string;
}): Promise<{ error: ApiError | null }> {
  const res = await api.patch("/profiles/me/password", data);
  return { error: res.error };
}

export async function deleteAccount(data: {
  password?: string;
}): Promise<{ error: ApiError | null }> {
  const res = await api.delete("/profiles/me", data);
  return { error: res.error };
}

export type NotificationPreferences = {
  userId: string;
  dailyGoal: number;
  leaderboard: number;
  competitionEnd: number;
  friendRequest: number;
};

export async function getNotificationPreferences(): Promise<{
  data: NotificationPreferences | null;
  error: ApiError | null;
}> {
  return api.get<NotificationPreferences>("/notifications/preferences");
}

export async function updateNotificationPreferences(
  prefs: Partial<Pick<NotificationPreferences, "competitionEnd" | "friendRequest">>,
): Promise<{ data: NotificationPreferences | null; error: ApiError | null }> {
  return api.put<NotificationPreferences>("/notifications/preferences", prefs);
}
